import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue'
import IconSvgWrap from './IconSvgWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCircleQuestion',
  props: {
    fillColor: { default: '' },
    size: { default: 16 }
  },
  setup(__props: any) {

const props = __props as { fillColor: string, size: number };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconSvgWrap, {
    size: props.size
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("svg", {
        width: props.size,
        height: props.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.43064 4.28993C8.00287 4.20985 7.55904 4.25061 7.15355 4.40869C6.7478 4.56687 6.39378 4.83754 6.14124 5.19326C6.03421 5.34402 5.94772 5.5069 5.88354 5.67783C5.84015 5.7934 5.81845 5.85119 5.83359 5.97327C5.8499 6.10487 5.98033 6.29316 6.0978 6.35469C6.20677 6.41176 6.30451 6.41176 6.5 6.41176H6.87568C7.08241 6.41176 7.24467 6.23017 7.36435 6.0616C7.44145 5.95299 7.55596 5.86177 7.69839 5.80624C7.84108 5.75061 8.00045 5.73546 8.15462 5.76432C8.30867 5.79316 8.44434 5.86337 8.54663 5.95965C8.64844 6.05546 8.71212 6.17188 8.73738 6.29143C8.76256 6.41054 8.75012 6.53456 8.69936 6.64991C8.65448 6.75187 8.60694 6.82577 8.39765 6.97514L8.38161 6.98656C8.13777 7.15983 7.25 7.7907 7.25 9C7.25 9.2761 7.47382 9.49993 7.74992 9.49995L8.25 9.49997C8.52614 9.49998 8.75 9.27613 8.75 9C8.75 8.5907 9.04038 8.35928 9.26906 8.19606C9.63175 7.9372 9.89009 7.66811 10.0723 7.25414C10.2486 6.85355 10.2955 6.40985 10.205 5.98126C10.1145 5.55309 9.89243 5.1664 9.57468 4.86735C9.25741 4.56874 8.85853 4.37004 8.43064 4.28993ZM8.2 12C8.48003 12 8.62004 12 8.727 11.9455C8.82108 11.8976 8.89757 11.8211 8.9455 11.727C9 11.62 9 11.48 9 11.2V10.8C9 10.52 9 10.38 8.9455 10.273C8.89757 10.1789 8.82108 10.1024 8.727 10.0545C8.62004 10 8.48003 10 8.2 10H7.8C7.51997 10 7.37996 10 7.273 10.0545C7.17892 10.1024 7.10243 10.1789 7.0545 10.273C7 10.38 7 10.52 7 10.8V11.2C7 11.48 7 11.62 7.0545 11.727C7.10243 11.8211 7.17892 11.8976 7.273 11.9455C7.37996 12 7.51997 12 7.8 12H8.2Z",
          fill: props.fillColor || '#00C378'
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    ]),
    _: 1
  }, 8, ["size"]))
}
}

})